module.exports = __webpack_public_path__ + "img/default-checked.07e442a3.png";